import {hasValue} from "@amsanalytics/react-shared-library";
import {CreateApplicationFromFormResults} from "./Models/CreateApplicationFromFormResults";
import {isNotNil} from "ramda";

export const shouldRedirectAutomatically = (
  createApplicationFromFormResults: CreateApplicationFromFormResults | null
) => {
  return createApplicationFromFormResults
    && hasValue(createApplicationFromFormResults.redirectUrl)
    && !createApplicationFromFormResults.redirectToCustomResultPage;
};

// returns true if we should redirect the customer to the portal login page after submitting the application. false indicates that we should redirect to the custom creditApplicationRedirectUrl.
/**
 * Triggers a file download from a fetch Response, matching the LOS saveFile pattern.
 * Extracts the filename from Content-Disposition if available, otherwise uses fallbackFileName.
 */
export const saveFile = async (response: Response, fallbackFileName: string) => {
  const blob = await response.blob();
  const contentDisposition = response.headers.get('content-disposition');
  let fileName = contentDisposition?.split(';')?.[1]?.split('filename')?.[1]?.split('=')?.[1]?.trim()
    ?? fallbackFileName;
  if (fileName.startsWith('"')) {
    fileName = fileName.substring(1);
  }
  if (fileName.endsWith('"')) {
    fileName = fileName.substring(0, fileName.length - 1);
  }

  const anchor = window.document.createElement('a');
  const objectUrl = window.URL.createObjectURL(blob);
  try {
    anchor.href = objectUrl;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
  } finally {
    document.body.removeChild(anchor);
    window.URL.revokeObjectURL(objectUrl);
  }
};

export const shouldRedirectToCustomerPortal = (
  createApplicationFromFormResults: CreateApplicationFromFormResults | null,
  clientId: string | null,
  customerPortalLinkId: string | null,
): boolean => {
  // The creditApplicationRedirectUrl will be null if the client has not set a custom redirect URL. This null-check is a temporary workaround to avoid redirecting to the portal login page when the client has not set a custom redirect URL.
  return !!createApplicationFromFormResults
    && !createApplicationFromFormResults.redirectToCustomResultPage
    && isNotNil(createApplicationFromFormResults?.redirectUrl)
    && !hasValue(createApplicationFromFormResults?.redirectUrl.trim())
    && hasValue(clientId)
    && hasValue(customerPortalLinkId);
};